import { useEffect, useState } from "react"
import { msUntilNextLocalMidnight } from "@/helpers/dayjs"

/**
 * Returns a monotonically increasing counter that increments once the
 * local date rolls over. Consumers pass the returned value as a `useMemo`
 * dependency to recompute date-derived views at midnight without polling.
 *
 * The effect re-arms itself from the new counter value, so a single hook
 * call stays active as long as the component is mounted.
 */
export const useMidnightTick = (): number => {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const id = window.setTimeout(() => {
      setTick((v) => v + 1)
    }, msUntilNextLocalMidnight())

    return () => window.clearTimeout(id)
  }, [tick])

  return tick
}
